var path = '/glow/component/glow-module/module-video-promo/tpl/module-video-promo.html';
var html = "<div class=glow-video-promo role=region aria-label={{$ctrl.name}}> <div class=glow-video-promo-wrapper ng-style=$ctrl.styles.wrapper ng-class=$ctrl.classes.wrapper> <thismoment-video-youtube ng-if=$ctrl.displayYoutube id={{::$ctrl.content.source.origin_id}} item=$ctrl.content placeholder={{::$ctrl.content.images.large.url}} video-url={{::$ctrl.content.videos.large.url}} autoplay=$ctrl.autoplayEnabled></thismoment-video-youtube> <video controls ng-if=$ctrl.displayVideo> <source ng-src={{$ctrl.content.videos.original.url}} type=video/mp4> </video> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/glow/component/glow-module/module-video-promo/tpl/module-video-promo.html
// module id = 1780
// module chunks = 1